import React, { HTMLProps } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import cn from 'classnames';

import './Loader.scss';

export interface LoaderProps extends Omit<HTMLProps<HTMLDivElement>, 'size'> {
  size?: 'xl' | 'l'; // Add more if needed
}

const Loader: React.FC<LoaderProps> = ({ className, size = 'xl', ...props }) => (
  <LoadingOutlined className={cn(className, 'baseLoader', `baseLoader-${size}`)} />
);

export default Loader;
